import ValidationRule from './validation.rule.js';

export default class HtmlNativeFeedbackRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.elements = [];

        this.getElements().forEach(element => {
            if (element.hasAttribute('novalidate') === false) {
                this.elements.push(element);
            }
        });

        this.elements.forEach(element => {
            const target = this.loadTarget(element);
            this.listenValidity(target);
        });
    }

    getRuleName() {
        return 'html-native-feedback';
    }


    clearValidity() {
        this.elements.forEach(element => {
            this.resetValidity(element);
        });
    }

    getMessage(eltToInvalidate) {
        if (eltToInvalidate.validity.customError === true) {
            return eltToInvalidate.validationMessage ?? '';
        }

        else {
            const message = eltToInvalidate.getAttribute('data-error-message');
            if (typeof message === "string" && message.length > 0) {
                return message;
            }
            else {
                return eltToInvalidate.validationMessage;
            }
        }
    }

    checkOne(element) {
        return element.checkValidity();
    }

    async check() {
        return this.targets.map(target => this.refreshValidity(target)).every(value => value === true);
    }

    setCustomErrorMessage(inputElement, feedbackElement, message) {
        if (inputElement.getAttribute('data-lock')) {
            return; // only one error message by element
        }

        inputElement.setAttribute('data-lock', true);

        inputElement.setCustomValidity(message);
        if (feedbackElement !== null) {
            feedbackElement.textContent = message;
        }
        else {
            inputElement.reportValidity();
        }
    }
}
